var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "button",
        {
          ref: "ordersButton",
          staticClass: "btn btn-sm",
          attrs: { id: "ordersButton", type: "button" },
          on: { click: _vm.toggleOrdersPopover }
        },
        [
          _vm.pendingOrdersAmount > 0
            ? _c("span", {
                staticClass: "order-button-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("ORDERS_PENDING_AMOUNT", {
                      amount: _vm.pendingOrdersAmount
                    })
                  )
                }
              })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.$t("NUMBER_ORDERS")) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "popover",
        {
          attrs: {
            "custom-class": "search-popover",
            placement: "bottom",
            "auto-placement": false,
            trigger: "manual",
            target: "#ordersButton"
          },
          on: {
            show: function($event) {
              _vm.showOrdersPopover = true
            },
            hide: function($event) {
              _vm.showOrdersPopover = false
            }
          },
          model: {
            value: _vm.showOrdersPopover,
            callback: function($$v) {
              _vm.showOrdersPopover = $$v
            },
            expression: "showOrdersPopover"
          }
        },
        [
          _c(
            "template",
            { slot: "popover" },
            [
              _vm.showOrdersPopover
                ? _c("NumberOrdersPopup", {
                    on: { closeModal: _vm.closeModal }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }